import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcListConfig, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-provider-modal-new-audit',
  templateUrl: './provider-modal-new-audit.component.html',
  styles: []
})
export class ProviderModalNewAuditComponent extends ExcTranslation implements OnInit {
  @ViewChild('frm') frm;
  isPreselected = false;
  preselectedCount = 0;
  step  = 1;
  selectedType = 'SC';
  year = new Date().getFullYear();
  month = new Date().getMonth() + 1;
  searchValuePickable = '';
  pickableList: any[] = [];
  selectedItems: any[] = [];
  pickableListConfig: ExcListConfig = new ExcListConfig();
  sc: {AnnouncementDate: any, AuditStartDate: any, AuditEndDate: any, AuditLevel: number, AuditDuration: number, Mode: string, Quota: number, Min: number, Max: number, Selection: []};
  fc: {PlanMonth: number, PlanYear: number, AuditAnnouncement: boolean, AuditType: number, IncludeDoc: boolean, IncludeFzg: boolean, Comment: string}; // , Auditor: string,  Mode: string, Quota: number, Min: number, Max: number, Selection: []};
  optLevel = [];
  optYesNo: {text: string, value: boolean, disabled: boolean}[] = [];
  optScModes: {text: string, value: string, disabled: boolean}[] = [];
  optFcTypes: {text: string, value: number, disabled: boolean}[] = [];
  datepickerConfigAnnouncement: any = {
    minDate: new Date(),
    maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    dateFormat: this.getGlobal('FormatDate'),
    static: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };
  datepickerConfigStart: any = {
    minDate: new Date(),
    maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    dateFormat: this.getGlobal('FormatDate'),
    static: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };
  datepickerConfigEnd: any = {
    minDate: new Date(),
    maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    dateFormat: this.getGlobal('FormatDate'),
    static: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };
  optYear: {text: string, value: number, disabled: boolean}[] = [];
  optMonth: {text: string, value: number, disabled: boolean}[] = [];
  years = [{text: this.year, value: this.year}, {text: this.year + 1, value: this.year + 1}
    , {text: this.year + 2, value: this.year + 2}, {text: this.year + 3, value: this.year + 3}];
  months = [
    {value: 1, text: this.getGlobal('JanLong'), disabled: false},
    {value: 2, text: this.getGlobal('FebLong'), disabled: false},
    {value: 3, text: this.getGlobal('MarLong'), disabled: false},
    {value: 4, text: this.getGlobal('AprLong'), disabled: false},
    {value: 5, text: this.getGlobal('MayLong'), disabled: false},
    {value: 6, text: this.getGlobal('JunLong'), disabled: false},
    {value: 7, text: this.getGlobal('JulLong'), disabled: false},
    {value: 8, text: this.getGlobal('AugLong'), disabled: false},
    {value: 9, text: this.getGlobal('SepLong'), disabled: false},
    {value: 10, text: this.getGlobal('OctLong'), disabled: false},
    {value: 11, text: this.getGlobal('NovLong'), disabled: false},
    {value: 12, text: this.getGlobal('DecLong'), disabled: false}
  ];
  addMore = false;
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService, private excRest: ExcRestService) {
    super();
    const _self = this;
    if (_self.overlayConfig.data.Preselected !== undefined && _self.overlayConfig.data.Preselected !== null) {
      _self.isPreselected = true;
      _self.preselectedCount = _self.overlayConfig.data.Preselected.items.length;
    }
    this.sc = {AnnouncementDate: new Date(), AuditStartDate: new Date(), AuditLevel: 1, AuditEndDate: new Date(), AuditDuration: null, Mode: 'Complete', Quota: null, Min: null, Max: null, Selection: []};
    this.fc = {PlanMonth: this.month, PlanYear: this.year, AuditAnnouncement: false, AuditType: 1, IncludeDoc: false, IncludeFzg: false, Comment: null};
    this.fc.IncludeDoc = this.overlayConfig.data['DefaultDocumentCheck'] === 21;
    this.fc.IncludeFzg = this.overlayConfig.data['DefaultObjectCheck'] === 21;
    if (this.overlayConfig.data['DealerResponsibleLevel3'] === true) {
      this.sc.AuditLevel = 3;
    } else if (this.overlayConfig.data['DealerResponsibleLevel2'] === true) {
      this.sc.AuditLevel = 2 ;
    } else {
      this.sc.AuditLevel = 1;
    }
    this.optLevel.push({text: (this.excDss.MandantSettings['Labels']['DealerLevel1'] || this.getGlobal('DealerLevel1')), value: 1, disabled: false});
    this.optLevel.push({text: (this.excDss.MandantSettings['Labels']['DealerLevel2'] || this.getGlobal('DealerLevel2')), value: 2, disabled: this.overlayConfig.data['DealerResponsibleLevel2'] !== true});
    this.optLevel.push({text: (this.excDss.MandantSettings['Labels']['DealerLevel3'] || this.getGlobal('DealerLevel3')), value: 3, disabled: this.overlayConfig.data['DealerResponsibleLevel3'] !== true});

    this.optYesNo.push({value: false, text: this.getGlobal('No'), disabled: false});
    this.optYesNo.push({value: true, text: this.getGlobal('Yes'), disabled: false});

    this.optScModes.push({value: 'Complete', text: this.getRessource('ModeComplete'), disabled: false});
    this.optScModes.push({value: 'Quota', text: this.getRessource('ModeQuota'), disabled: false});
    this.optScModes.push({value: 'Picked', text: this.getRessource('ModePicked'), disabled: false});

    for (const x of this.excDss.MandantSettings['FCTypes']) {
      this.optFcTypes.push({value: x['value'], text: x['text'], disabled: false});
    }
    this.setFcTimeOpts(null);
    if (this.isPreselected === true) {
      this.sc.Mode = 'Picked';
      this.sc.AuditLevel = 1;
    }
    _self.pickableListConfig.selectionMode = 'multi';
    _self.pickableListConfig.selectionKey = 'InventoryVIN';
    _self.pickableListConfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.pickableListConfig.OnSelectionChanged = (selectedItems) => {
      _self.selectedItems = selectedItems;
    };
    _self.pickableListConfig.OnSearch = function (searchValue, event?) {
      _self.searchValuePickable = searchValue || '';
      _self.reloadPickableInventory();
    };
    _self.pickableListConfig.OnPageChanged = (pageNo, event1) => {
      _self.pickableListConfig.paging.pagingPage = pageNo;
      _self.reloadPickableInventory();
    };
    _self.pickableListConfig.OnRefresh = () => {
      _self.reloadPickableInventory();
    };
  }

  handleAuditAnnouncementChanged() {

  }
  handleAuditStartChanged() {
    this.datepickerConfigAnnouncement.maxDate = (this.sc.AuditStartDate === null ? (new Date()).setFullYear((new Date()).getFullYear() + 5) : this.sc.AuditStartDate );
    this.datepickerConfigEnd.minDate = (this.sc.AuditStartDate === null ? new Date() : this.sc.AuditStartDate);
  }
  handleAuditEndChanged() {
    this.datepickerConfigStart.maxDate = (this.sc.AuditEndDate === null ? (new Date()).setFullYear((new Date()).getFullYear() + 5)  : this.sc.AuditEndDate);
  }
  setFcTimeOpts(e) {
    const _self = this;
    for (const m of _self.months) {
      if (this.fc.PlanYear === _self.year) {
        m.disabled = m.value < _self.month;
      } else {
        m.disabled = false;
      }
    }
    if (this.year === _self.fc.PlanYear) {
      if (this.fc.PlanMonth < _self.month) {
        this.fc.PlanMonth = _self.month;
      }
    }
  }
  isNextDisabled() {
    if (this.step === 1) {
      if (this.selectedType === 'SC') {
        if (this.sc.Mode === 'Quota') {
          return this.sc.AuditDuration === null || this.sc.AuditLevel === null || this.sc.AnnouncementDate === null
            || this.sc.AuditStartDate === null || this.sc.AuditEndDate === null
            || this.sc.Quota === null || this.sc.Max === null || this.sc.Min === null;
        } else {
          return this.sc.AuditDuration === null || this.sc.AuditLevel === null || this.sc.AnnouncementDate === null
            || this.sc.AuditStartDate === null || this.sc.AuditEndDate === null;
        }
      } else {
        return this.fc.AuditAnnouncement === null || this.fc.AuditType === null || this.fc.PlanYear === null
          || this.fc.IncludeDoc === null || this.fc.IncludeFzg === null || this.fc.PlanMonth === null;
      }
    } else {
      return this.selectedItems.length === 0;
    }
  }

  fuckDate(d: any) {
    const dt = new Date(d);
    let x = dt.getTime();
    x = x - ((new Date()).getTimezoneOffset() * 60 * 1000);
    return new Date(x);
  }
  proceed() {
    const _self = this;
    if (this.step === 1 && this.selectedType === 'SC' && this.sc.Mode === 'Picked' && this.isPreselected === false) {
      this.step  = 2;
      this.reloadPickableInventory();
    } else {
      const audit = {
        Type: this.selectedType,
        Data: {}
      };
      if (this.selectedType === 'SC') {
        audit.Data = {
          AuditAnnouncementDate: this.fuckDate(this.sc.AnnouncementDate),
          AuditStartDate: this.fuckDate(this.sc.AuditStartDate),
          AuditEndDate: this.fuckDate(this.sc.AuditEndDate),
          AuditLevel: this.sc.AuditLevel,
          Duration: this.sc.AuditDuration,
          Quota: this.sc.Mode === 'Quota' ? this.sc.Quota : null,
          Min: this.sc.Mode === 'Quota' ? this.sc.Min : null,
          Max: this.sc.Mode === 'Quota' ? this.sc.Max : null
          , DealerID: this.overlayConfig.data['DealerID']
          , PickedData: null
        };
        if (this.isPreselected === true) {
          let pd = '';
          for (const x of _self.overlayConfig.data.Preselected.items) {
            if (pd === '') {
              pd = x;
            } else {
              pd = pd + '|' + x;
            }
          }
          audit.Data['PickedData'] = pd;
          audit.Data['PickedMode'] = _self.overlayConfig.data.Preselected.mode;
        } else {
          if (this.sc.Mode === 'Picked') {
            let vins = '';
            for (const x of this.selectedItems) {
              if (vins === '') {
                vins = x['InventoryVIN'];
              } else {
                vins = vins + '|' + x['InventoryVIN'];
              }
            }
            audit.Data['PickedData'] = vins;
            audit.Data['PickedMode'] = 'STOCK';
          }
        }
      } else {
        audit.Data = {
          AuditMonth: this.fc.PlanMonth
          , AuditYear: this.fc.PlanYear
          , AuditLevel: this.sc.AuditLevel
          , AuditAnnouncement: this.fc.AuditAnnouncement
          , AuditIncludeObjects: this.fc.IncludeFzg
          , AuditIncludeDocuments: this.fc.IncludeDoc
          , AuditType: this.fc.AuditType
          , AuditComment: this.fc.Comment
          , DealerID: this.overlayConfig.data['DealerID']
        };
      }
      this.overlayRef.close({proceed: true, Audit: audit, addMore: _self.addMore});
    }
  }
  reloadPickableInventory() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerPickableInventoryR_List', {DealerID: this.overlayConfig.data['DealerID'], Level: this.sc.AuditLevel, fts: this.searchValuePickable == null ? '' : this.searchValuePickable});
    const mi = this.pickableListConfig.GetMetaInfo();
    _self.pickableListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.pickableList = ret.data;
        _self.pickableListConfig.paging = ret.paging;
        _self.pickableListConfig.isLoading = false;
      }
    });
  }

  ngOnInit() {
    if (this.overlayConfig.data['IsFirstCall'] === true) {
      // Erster Call ohne Flag
      this.addMore = false;
    } else {
      // Alle anderen CAlls mit Flag
      this.addMore = this.overlayConfig.data['AddMore'];
    }
    if (!this.overlayConfig.data['DealerEmail']) {
      this.selectedType = 'FC';
    }
  }

  hasDealerEmail() {
    const _self = this;
    return _self.overlayConfig.data.DealerEmail !== '' && _self.overlayConfig.data.DealerEmail && _self.overlayConfig.data.DealerEmail !== null  ;
  }
}
